import { actionGenerator } from '../../../utils/redux/actionGenerator';
import { TGetDocumentGroupListSucceed, EGetDocumentGroupListActionType } from './types';
import { IDocumentGroup } from '../../../types/documentGroupList';

export const getDocumentGroupListSucceed: (data: IDocumentGroup[]) => TGetDocumentGroupListSucceed = actionGenerator<
  EGetDocumentGroupListActionType.Succeed,
  IDocumentGroup[]
>(EGetDocumentGroupListActionType.Succeed);
